import Table, { TableProps } from '@mui/material/Table'
import { alpha, styled } from '@mui/material/styles'

interface StyledTableProps extends TableProps {
    striped?: boolean
    hover?: boolean
    bordered?: boolean
}

export const StyledTable = styled(Table, {
    shouldForwardProp: (prop) =>
        prop !== 'striped' && prop !== 'hover' && prop !== 'bordered',
})<StyledTableProps>(({ theme, striped, hover, bordered }) => ({
    ...(bordered && {
        borderCollapse: 'collapse',
        '& .MuiTableCell-root': {
            border: `1px solid ${theme.palette.divider}`,
        },
    }),
    ...(striped && {
        '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(odd)': {
            backgroundColor: alpha(theme.palette.grey[100], 0.5),
        },
        '& .MuiTableBody-root .MuiTableRow-root:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    }),
    ...(hover && {
        '& .MuiTableBody-root .MuiTableRow-root:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    }),
}))
